import { IUsageCostItem } from "@formant/core/model/IUsageCostItem";

export const getTotalUsage = (costItems: IUsageCostItem[]) => {
    return costItems.reduce((previous, current) => {
        if (
            current.type === "data-in-count" ||
            current.type === "data-in-bytes" ||
            current.type === "data-out-bytes" ||
            current.type === "data-stored-bytes"
        ) {
            return (previous += current.costUsdCents);
        }
        return previous;
    }, 0);
};
